import { Component, DoCheck, EventEmitter, Input, Output } from '@angular/core';
import { getDisabledUserManagementTooltipText } from 'src/app/project/modules/user-management/user-management-table-cells/utils/get-disabled-user-management-cell-tooltip-text';
import { TShare } from '../../../../../../share/share.model';

@Component({
    selector: 'pp-account-user-modal-shares-list-share-exports',
    templateUrl: './account-user-modal-shares-list-share-exports.component.html',
    styleUrls: ['./account-user-modal-shares-list-share-exports.component.scss'],
    standalone: false
})
export class AccountUserModalSharesListShareExportsComponent implements DoCheck {
  @Input() ppShare: TShare;
  @Output() ppShareChange = new EventEmitter<TShare>();
  @Input() ppDisabled: boolean;
  viewPermission: boolean;
  disabledTooltipText: string;

  ngDoCheck(): void {
    this.setViewPermission();
  }

  private setViewPermission(): void {
    this.viewPermission = this.ppShare.advancedAccessLevels.exports.permission.read;
    this.disabledTooltipText = getDisabledUserManagementTooltipText(this.ppShare.shareOption);
  }

  changeViewPermission(): void {
    this.viewPermission = !this.viewPermission;

    const newShare = { ...this.ppShare };
    newShare.advancedAccessLevels.exports.permission.read = this.viewPermission;

    this.ppShareChange.emit(newShare);
  }
}
